module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "about-the-book"
    }
  }, [_c('h1', {
    staticStyle: {
      "margin-top": "250px"
    }
  }, [_vm._v("About the Book")]), _vm._v(" "), _c('p', [_vm._v("A product of two cultures and academic worlds—Indian and American—Dr. Satyam Sikha Moorty (S.S. Moorty) taught literature courses for thirty-one years at Southern Utah University, Cedar City, Utah, U.S.A. Award-winning essayist, poet, scholar, and editor, Dr. Moorty was a Fulbright Professor/Specialist in Moldova (thrice), Austria, Azerbaijan, and Yemen, and a Balkan Scholar in Bulgaria. He published his poetry in the U.S., India, England, South Africa, Canada, and Moldova. He has published two books: 1) “Distant Lands, Diverse Cultures” and 2) “Moldova: Vigorous Heritage and Variegated Traditions: Poems, Essays, Stories, and Speeches”. His work examines his inter-cultural observations and experiences.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c22c3d46","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/ch002.vue
// module id = 66
// module chunks = 0